import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from "ngx-translate-multi-http-loader";
import { HttpClientModule, HttpBackend } from '@angular/common/http';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';
import { AppComponent } from './app-vaf.component';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { FileSaverModule } from 'ngx-filesaver';
import { CommonModule, DatePipe } from '@angular/common';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomMatPaginatorIntl } from './services/matPaginatorIntl';
import 'hammerjs';

//tables
import { TableComponentModule } from './components/table/table.component.module';
import { TableExtractionComponentModule } from './components/table-extraction/table-extraction.component.module';
import { TableSettingsComponentModule } from './components/table-settings/table-settings.component.module';
import { TablePopupInputComponentModule } from './components/table/table-popup-input/table-popup-input.component.module';
import { TableTdComponentModule } from './components/table/table-td/table-td.component.module';

//pages & components
import { GroupByPipeModule } from './pipes/group-by-pipe/group-by.pipe.module';
import { OrderByPipeModule } from './pipes/order-by-pipe/order-by.pipe.module';
import { FilterPipeModule } from './pipes/filter-pipe/filter.pipe.module';
import { DateFormatPipeModule } from './pipes/date-format/date-format.pipe.module';
import { DateFormatPlaceholderPipeModule } from './pipes/date-format-placeholder-pipe/date-format-placeholder.pipe.module';
import { CurrencyFormatPipeModule } from './pipes/currency/currency.pipe.module';
import { VafCommonService } from './services/vaf-common.service';
import { NumberSeparatorPipeModule } from './pipes/number-separator/number-separator.pipe.module';
import { VafCertificationDetailComponentModule } from './modals/vaf-certification-detail/vaf-certification-detail.component.module';
import { VafFineDetailComponentModule } from './modals/vaf-fine-detail/vaf-fine-detail.component.module';
import { RejectRegistrationComponentModule } from './modals/reject-registration/reject-registration.component.module';
import { VafUserDetailComponentModule } from './modals/vaf-user-detail/vaf-user-detail.component.module';
import { VafFineCardComponentModule } from './components/vaf-fine-card/vaf-fine-card.component.module';
import { VafFinesFileUploadModule } from './modals/vaf-fines-file-upload/vaf-fines-file-upload.component.module';
import { VafLogResponseComponentModule } from './components/vaf-log-response-component/vaf-log-response-component.component.module';
import { VafLogResponsetModalModule } from './modals/vaf-log-response-modal/vaf-log-response-modal.component.module';
import { VafPaymentCardComponentModule } from './components/vaf-payment-card/vaf-payment-card.component.module';
import { VafPaymentDetailComponentModule } from './modals/vaf-payment-detail/vaf-payment-detail.component.module';



export function initializeApp(commonService: VafCommonService) {
  return (): Promise<any> => {
    return commonService.startup();
  };
}


@NgModule({

  declarations: [
    AppComponent
  ],
  imports: [
    FileSaverModule,
    BrowserModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    IonicModule.forRoot({
      rippleEffect: false,
      mode: 'md'
    }),
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend]
      }
    }),
    IonicStorageModule.forRoot(),
    FormsModule,
    CommonModule,
    TableComponentModule,
    TableSettingsComponentModule,
    TableExtractionComponentModule,
    TablePopupInputComponentModule,
    TableTdComponentModule,
    GroupByPipeModule,
    OrderByPipeModule,
    FilterPipeModule,
    DateFormatPipeModule,
    DateFormatPlaceholderPipeModule,
    CurrencyFormatPipeModule,
    NumberSeparatorPipeModule,
    VafCertificationDetailComponentModule,
    VafFineDetailComponentModule,
    RejectRegistrationComponentModule,
    VafUserDetailComponentModule,
    VafFineCardComponentModule,
    VafFinesFileUploadModule,
    VafLogResponseComponentModule,
    VafLogResponsetModalModule,
    VafPaymentCardComponentModule,
    VafPaymentDetailComponentModule
  ],
  providers: [
    DatePipe,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    DatePipe,
    {
      provide: MatPaginatorIntl,
      useClass: CustomMatPaginatorIntl
    }, {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [VafCommonService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }




// required for AOT compilation
export function HttpLoaderFactory(http: HttpBackend) {
  let translationsUrl: string;
  if (document.baseURI.indexOf('/test-') != -1 || document.baseURI.indexOf('/localhost') != -1)
    translationsUrl = 'https://safomf-mfeassets.azurewebsites.net/mfe-assets/i18n/';
  else if (document.baseURI.indexOf('/stage.') != -1 || document.baseURI.indexOf('/stage-') != -1)
    translationsUrl = 'https://safomf-mfeassets-stage.azurewebsites.net/mfe-assets/i18n/';
  else
    translationsUrl = 'https://safomf-mfeassets-prod.azurewebsites.net/mfe-assets/i18n/';
  return new MultiTranslateHttpLoader(http, [
    { prefix: "./assets/i18n/", suffix: ".json" },
  ]);
}

/*// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}*/

/*// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new MultiTranslateHttpLoader(http, [
    { prefix: "./assets/i18n/", suffix: ".json" }
  ]);
}*/